import {
  Card,
  CardHeader,
  Dialog,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  tabsClasses,
  Autocomplete,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import React, { SyntheticEvent, useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Typography,
  TextField,
  MenuItem,
  FormControl,
  InputAdornment,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  useDeleteProductMutation,
  useGetProductQuery,
  useGetProductCategoryQuery,
  useGetCategoryQuery,
  useGetAllMainCategoryQuery,
  useGetSubCategoryByArrayQuery,
  useSentToManagerOrderListMutation,
  useGetAllGetOrderListHistoryQuery,
  useGetOrderListByIdQuery,
  useGetBrandQuery,
  useGetTagQuery,
  useGetMainItemQuery,
  useGetRestaurantQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IOrderItemEdit,
  IOrderItemSetUpEdit,
  IOrderList,
  IVariantView,
  IBrand,
  ITag,
  IMainItem,
  IRestaurant,
  CustomerOption,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import { Dayjs } from "dayjs";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { useNavigate, useParams } from "react-router-dom";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import { useFormik } from "formik";
import { Privileges, SizeOfLevelType } from "../../../Core/Enum/enum";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { CiEdit } from "react-icons/ci";
import NewPopUpProduct from "../../Product/Edit/index";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import NewColor from "../../ThemeColor/Component/index";
import RefreshIcon from "@mui/icons-material/Refresh";
import useUser from "../../../Core/hook/useUser";
import ClassRoundedIcon from "@mui/icons-material/ClassRounded";
import RemoveIcon from "@mui/icons-material/Remove";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { capitalizeFirstLetter } from "../../../Components/Validation/capitalizeFirstLetter";
import useIsMobile from "../../../Core/hook/useIsMobile";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { userHasRight } = useUser();
  const theme = useTheme();
  const isMobileRes = useIsMobile();
  const { id: orderListHistoryId } = useParams<{ id: string }>();
  const getFormattedDate = (createDate: Dayjs | null): string => {
    return createDate ? createDate.format("YYYY-MM-DD") : "";
  };
  const [activeTab, setActiveTab] = useState(0);
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [selectedProductBrandId, setSelectedProductBrandId] =
    useState<string>("");
  const [selectedProductCategoryId, setSelectedProductCategoryId] =
    useState<string>("");
  const [selectedMainItemId, setSelectedMainItemId] = useState<string>("");

  const [selectedProductTagIds, setSelectedProductTagIds] = useState<string[]>(
    []
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [selectedProductViewOnline, setSelectedProductViewOnline] =
    useState<string>("");
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const startDateAsDate = startDate?.toDate() || null;
  const endDateAsDate = endDate?.toDate() || null;
  const [createDate, setCreateDate] = useState<Dayjs | null>(null);
  const [isPaperVisible, setIsPaperVisible] = useState(false);
  const [orderList, setOrderList] = useState<IOrderItemEdit[]>([]);
  const [editData, setEditData] = useState<IOrderItemSetUpEdit | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [openTax, setOpenTax] = useState(false);

  const [openRemarkId, setOpenRemarkId] = useState<string | null>(null);

  const {
    data: OrderListDate,
    isLoading: OrderListDateIsLoading,
    isError: OrderListDateIsError,
  } = useGetOrderListByIdQuery({
    searchText: currentSearchQuery,
    id: String(orderListHistoryId),
  });

  const {
    data: orderListData,
    isLoading: orderListIsLoading,
    isError: orderListIsError,
    refetch: orderListRefetch,
  } = useGetAllGetOrderListHistoryQuery({
    orderId: String(orderListHistoryId),
    searchText: "",
  });

  const orderListHisrotyRecord = useMemo(() => {
    return orderListData?.data as IOrderItemEdit[];
  }, [orderListData?.data]);

  const orderListDate = useMemo(() => {
    return OrderListDate?.data as IOrderList[];
  }, [OrderListDate?.data]);

  const ReDateId =
    orderListDate?.length > 0 ? orderListDate[0].orderListId : null;

  const BranchId =
    orderListDate?.length > 0 ? orderListDate[0].restaurantsId : "";

  useEffect(() => {
    if (orderListHisrotyRecord) {
      setOrderList(orderListHisrotyRecord);
    }
  }, [orderListHisrotyRecord]);

  const [newOrderList, { isLoading: OrderListIsLoading }] =
    useSentToManagerOrderListMutation();

  const { data: categoryData } = useGetAllMainCategoryQuery({
    departmentId: "",
    coursingId: "",
    roleId: null,
    taxeId: "",
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    numberOfLength: 0,
    isActive: true,
    categoryIsLooping: null,
    createdDate: null,
  });

  const { data: restaurantData, isLoading: restauramtIsLoading } =
    useGetRestaurantQuery({
      searchText: "",
      id: "",
    });

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const { data: subCategoryData, refetch: refetchSubCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
    });

  const { data: subCategory2Data, refetch: refetchS2bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
        : [],
    });

  const { data: subCategory3Data, refetch: refetchS3bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [
            Number(selectedCategoryId),
            Number(selectedSubCategoryId),
            Number(selectedSubToSubCategoryId),
          ]
        : [],
    });
  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const subCategoryList = useMemo(() => {
    return subCategoryData?.data as ICategory[];
  }, [subCategoryData?.data]);

  const subToSubCategoryList = useMemo(() => {
    return subCategory2Data?.data as ICategory[];
  }, [subCategory2Data?.data]);

  const subToSubToSubCategoryList = useMemo(() => {
    return subCategory3Data?.data as ICategory[];
  }, [subCategory3Data?.data]);

  const restaurantList = useMemo(() => {
    return restaurantData?.data as IRestaurant[];
  }, [restaurantData?.data]);

  const restaurantOptions = useMemo(() => {
    if (!Array.isArray(restaurantList)) return [];
    return restaurantList.map((cust) => ({
      label: `${capitalizeFirstLetter(cust.restaurantsName)}`,
      value: cust.id,
    }));
  }, [restaurantList]);

  const categoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");

  const { data, isLoading, isError, refetch } = useGetProductQuery({
    variantBrandId: selectedProductBrandId,
    categoryId: String(categoryId),
    variantTagId: selectedProductTagIds,
    productViewOnline: selectedProductViewOnline,
    createdDateStart: startDateAsDate as Date,
    createdDateEnd: endDateAsDate as Date,
    searchText: currentSearchQuery,
    createdDate: getFormattedDate(createDate),
    id: null,
    mainItemId: selectedMainItemId,
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedProduct, setSelectedProduct] = useState<IVariantView | null>(
    null
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
  const [productToDelete, setProductToDelete] = useState<IVariantView | null>(
    null
  );

  const { data: productCategoryData, isLoading: productCategoryLoading } =
    useGetProductCategoryQuery({
      searchText: "",
      isActive: true,
    });

  const { data: productBrandData, isLoading: ProductBrandLoading } =
    useGetBrandQuery({
      searchText: "",
      isActive: "1",
      id: "",
    });
  const { data: productTagData, isLoading: ProductTagLoading } = useGetTagQuery(
    {
      searchText: "",
      isActive: "1",
      id: "",
    }
  );

  const { data: mainItemData, isLoading: mainItemIsLoading } =
    useGetMainItemQuery({
      searchText: "",
      id: "",
      variantBrandId: null,
      categoryId: null,
      variantTagId: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
    });

  const productBrandList = useMemo(() => {
    return productBrandData?.data as IBrand[];
  }, [productBrandData?.data]);

  const productTagList = useMemo(() => {
    return productTagData?.data as ITag[];
  }, [productTagData?.data]);

  const mainItemList = useMemo(() => {
    return mainItemData?.data as IMainItem[];
  }, [mainItemData?.data]);

  const handleMainCategoryChange = (event: SyntheticEvent, value: any) => {
    const categoryId = value as number;
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = categoryList.find(
      (category) => category.id === categoryId
    );
  };

  const handleSubCategoryChange = (event: SyntheticEvent, value: any) => {
    const subCategoryId = value as number;
    setSelectedSubCategoryId(subCategoryId);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = subCategoryList.find(
      (category) => category.id == subCategoryId
    );
  };

  const handleSubToSubCategoryChange = (event: SyntheticEvent, value: any) => {
    const selectedSubToSubCategoryId = value as number;
    setSelectedSubToSubCategoryId(selectedSubToSubCategoryId);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = subToSubCategoryList.find(
      (category) => category.id == selectedSubToSubCategoryId
    );
  };

  const handleSubToSubToSubCategoryChange = (
    event: SyntheticEvent,
    value: any
  ) => {
    const selectedSubToSubToSubCategoryId = value as number;
    setSelectedSubToSubToSubCategoryId(selectedSubToSubToSubCategoryId);

    const selectedCategory = subToSubToSubCategoryList.find(
      (category) => category.id == selectedSubToSubToSubCategoryId
    );
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleOpenDialog = (product: IVariantView) => {
    setSelectedProduct(product);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialog(false);
  };

  const handleProductBrandChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductBrandId(selectedValues);
  };

  const handleMainItemChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedMainItemId(selectedValues);
  };

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue);
  };

  const handleCreateDateChange = (newValue: Dayjs | null) => {
    setCreateDate(newValue);
  };

  const toggleRemarkContainer = (productId: string) => {
    setOpenRemarkId(openRemarkId === productId ? null : productId);
  };

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

  const handleProductTag = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;
    setSelectedProductTagIds(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleEditOpen = (row: IVariantView) => {
    const transformedRow: IOrderItemSetUpEdit = {
      id: null,
      productId: row.id,
      variantName: row.variantName,
      variantUnit: row.variantUnit,
      quantityKgOrLi: row.quantityKgOrLi,
      quantitySmallUnit: row.quantitySmallUnit,
      remark: row.remark,
    };

    setEditData(transformedRow);
    setIsEditDialogOpen(true);
  };

  const handleEditClose = () => {
    setEditData(null);
    setIsEditDialogOpen(false);
  };

  const handleCancelOrderList = () => {
    setOrderList([]);
  };

  const handleQuantityChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: keyof IOrderItemSetUpEdit
  ) => {
    const value = field === "remark" ? e.target.value : Number(e.target.value);

    setEditData((prevData) => {
      if (!prevData) return null;

      return {
        ...prevData,
        [field]: value,
      };
    });
  };

  const handleQuantityChangeMain = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string,
    index: number
  ) => {
    // const value = Number(e.target.value);
    const value = field === "remark" ? e.target.value : Number(e.target.value);

    setOrderList((prevOrderList) =>
      prevOrderList.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  };

  const handleDeleteRow = (productId: string) => {
    setOrderList((prevOrderList) =>
      prevOrderList.filter((row) => row.productId !== productId)
    );
  };

  const handleAddToOrder = (product: IOrderItemSetUpEdit) => {
    let totalQuantity = 0;

    if (product.variantUnit === 3 || product.variantUnit === 5) {
      totalQuantity =
        product.quantityKgOrLi +
        parseFloat(((product.quantitySmallUnit || 0) / 1000).toFixed(3));
    } else {
      totalQuantity = product.quantityKgOrLi;
    }

    const existingItemIndex = orderList.findIndex(
      (item) => item.productId === product.productId
    );

    if (existingItemIndex > -1) {
      const updatedOrderList = [...orderList];

      // updatedOrderList[existingItemIndex].productTotalUnit += totalQuantity;

      // updatedOrderList[existingItemIndex].remark = product.remark;

      const existingItem = {
        ...updatedOrderList[existingItemIndex],
        productTotalUnit:
          updatedOrderList[existingItemIndex].productTotalUnit + totalQuantity,
        remark: product.remark,
      };

      updatedOrderList[existingItemIndex] = existingItem;

      setOrderList(updatedOrderList);
    } else {
      setOrderList((prevOrderList) => [
        ...prevOrderList,
        {
          productId: product.productId,
          variantName: product.variantName,
          variantUnit: product.variantUnit,
          productTotalUnit: totalQuantity,
          remark: product.remark,
        },
      ]);
    }
  };

  // const handleAddToOrder = (product: IProductOrderList) => {
  //   let totalQuantity = 0;

  //   if (product.variantUnit === 3 || product.variantUnit === 5) {
  //     // Convert smaller units if provided
  //     totalQuantity =
  //       quantities.quantityKgOrLi + quantities.quantitySmallUnit / 1000;
  //   } else {
  //     // For other units, use quantity directly
  //     totalQuantity = quantities.quantityKgOrLi;
  //   }

  //   const existingItemIndex = orderList.findIndex(
  //     (item) => item.productId === product.id
  //   );

  //   if (existingItemIndex > -1) {
  //     const updatedOrderList = [...orderList];
  //     updatedOrderList[existingItemIndex].productTotalUnit += totalQuantity;
  //     setOrderList(updatedOrderList);
  //   } else {
  //     setOrderList((prevOrderList) => [
  //       ...prevOrderList,
  //       {
  //         productId: product.id,
  //         variantName: product.variantName,
  //         variantUnit: product.variantUnit,
  //         productTotalUnit: totalQuantity,
  //       },
  //     ]);
  //   }

  //   // Reset quantity fields
  //   setQuantities({ quantityKgOrLi: 0, quantitySmallUnit: 0 });
  // };

  const formik = useFormik({
    initialValues: {
      orderListId: "",
      orderList: [],
      restaurantsId: BranchId,
    },

    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          orderListId: String(orderListHistoryId),
          orderList: orderList,
          restaurantsId: values.restaurantsId,
        };
        const addCompanyResponse = await newOrderList(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          setOrderList([]);
          navigate(`/order/list/view/${orderListHistoryId}`);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  useEffect(() => {
    if (orderListDate?.length > 0) {
      formik.setFieldValue("restaurantsId", BranchId);
    }
  }, [orderListDate]);

  const formValid = useMemo(() => {
    return (
      formik.values.restaurantsId !== "" &&
      formik.values.restaurantsId !== undefined &&
      orderList.length > 0
    );
  }, [formik.values.restaurantsId, orderList]);

  const coursings: IVariantView[] = Array.isArray(data?.data)
    ? (data?.data as IVariantView[])
    : [];

  const resetFields = () => {
    setSelectedProductBrandId("");
    setSelectedProductCategoryId("");
    setSelectedProductViewOnline("");
    setSelectedProductTagIds([]);
    setStartDate(null);
    setEndDate(null);
    setCreateDate(null);
    setSelectedCategoryId(null);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
    setSearchQuery("");
    setSelectedMainItemId("");
  };

  const handleSearch = () => {
    setCurrentSearchQuery(searchQuery);
  };

  const resetSearchFields = () => {
    setSearchQuery("");
    setCurrentSearchQuery("");
    refetch();
  };

  const handleAddProductClick = () => {
    navigate("/product/create");
  };

  if (
    isLoading ||
    orderListIsLoading ||
    OrderListDateIsLoading ||
    ProductBrandLoading ||
    ProductTagLoading ||
    mainItemIsLoading ||
    restauramtIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={8} md={6} sm={12} xs={12}>
        <Card className={classes.orderListLeftCard}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ padding: 2, borderBottom: 4 }}
            className={classes.orderListLeftHeader}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CiSearch
                            className={classes.orderListSearchWidgetIcon}
                          />
                        </InputAdornment>
                      ),
                      classes: {
                        root: classes.formControlList,
                      },
                    }}
                    fullWidth
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Name & Display Name.."
                    className={classes.orderListTextField}
                    size="small"
                    sx={{ minWidth: "300px" }}
                  />
                </Grid>
                <Grid item>
                  <Button
                    startIcon={<FilterAltIcon />}
                    className={classes.ordeListButton}
                    onClick={handleToggle}
                  >
                    {isPaperVisible ? "Close Filter" : "Open Filter"}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    // variant="contained"
                    startIcon={<RefreshIcon />}
                    className={classes.ordeListButton}
                    onClick={resetFields}
                  >
                    Refresh
                  </Button>
                </Grid>
                {userHasRight(Privileges.ThemeView) && (
                  <Grid item>
                    <Button
                      // variant="contained"
                      startIcon={<ColorLensIcon />}
                      className={classes.ordeListButton}
                      onClick={() => {
                        setOpenTax(true);
                      }}
                    >
                      Set Theme
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          {isPaperVisible && (
            <>
              <Grid
                container
                spacing={2}
                my={2}
                px={1}
                sx={{ padding: 2, borderBottom: 4 }}
                className={classes.orderListLeftHeader}
              >
                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        Product
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        select
                        size="small"
                        value={selectedMainItemId || ""}
                        onChange={handleMainItemChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{ flexGrow: 1, width: "100%" }}
                        InputProps={{
                          classes: {
                            root: classes.formControlListStatus,
                          },
                        }}
                        className={classes.orderListTextField}
                      >
                        <MenuItem value="" style={{ color: "gray" }}>
                          Select an option
                        </MenuItem>
                        {mainItemList.map((mainitem) => (
                          <MenuItem key={mainitem.id} value={mainitem.id}>
                            {mainitem.mainItemName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>Brand</Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        select
                        size="small"
                        value={selectedProductBrandId || ""}
                        onChange={handleProductBrandChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{ flexGrow: 1, width: "100%" }}
                        InputProps={{
                          classes: {
                            root: classes.formControlListStatus,
                          },
                        }}
                        className={classes.orderListTextField}
                      >
                        <MenuItem value="" style={{ color: "gray" }}>
                          Select an option
                        </MenuItem>
                        {productBrandList.map((productBrand) => (
                          <MenuItem
                            key={productBrand.id}
                            value={productBrand.id}
                          >
                            {productBrand.brandName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>Tag</Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        select
                        size="small"
                        SelectProps={{
                          multiple: true,
                          native: false,
                        }}
                        InputLabelProps={{ shrink: true }}
                        value={selectedProductTagIds || ""}
                        onChange={handleProductTag}
                        sx={{ flexGrow: 1, width: "100%" }}
                        InputProps={{
                          classes: {
                            root: classes.formControlListStatus,
                          },
                        }}
                        className={classes.orderListTextField}
                      >
                        {productTagList && productTagList.length > 0 ? (
                          productTagList.map((productTag: ITag) => (
                            <MenuItem key={productTag.id} value={productTag.id}>
                              {productTag.tagName}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value="" style={{ color: "gray" }}>
                            Select an option
                          </MenuItem>
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        Create Date
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          onChange={handleCreateDateChange}
                          value={createDate}
                          className={classes.orderListTextField}
                          slotProps={{
                            textField: {
                              placeholder: "Create Date",
                              size: "small",
                              sx: {
                                width: "140px",
                              },
                              InputProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                                // classes: {
                                //   // root: classes.textFieldQuote,
                                // },
                                classes: {
                                  root: classes.formControlListStatus,
                                },
                              },
                              InputLabelProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        Start Date
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          onChange={handleStartDateChange}
                          value={startDate}
                          className={classes.orderListTextField}
                          slotProps={{
                            textField: {
                              placeholder: "Start Date",
                              size: "small",
                              sx: {
                                width: "140px",
                              },
                              InputProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                                // classes: {
                                //   // root: classes.textFieldQuote,
                                // },
                                classes: {
                                  root: classes.formControlListStatus,
                                },
                              },
                              InputLabelProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.OLbody2}>
                        End Date
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          onChange={handleEndDateChange}
                          value={endDate}
                          className={classes.orderListTextField}
                          slotProps={{
                            textField: {
                              placeholder: "End Date",
                              size: "small",
                              sx: {
                                width: "140px",
                              },
                              InputProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                                // classes: {
                                //   // root: classes.textFieldQuote,
                                // },
                                classes: {
                                  root: classes.formControlListStatus,
                                },
                              },
                              InputLabelProps: {
                                sx: {
                                  fontSize: 14,
                                  // color: "#97c3df",
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      <Button
                        // variant="contained"
                        startIcon={<RefreshIcon />}
                        className={classes.ordeListButton}
                        onClick={resetFields}
                      >
                        Refresh
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        startIcon={<FilterAltIcon />}
                        className={classes.ordeListButton}
                        onClick={handleToggle}
                      >
                        {isPaperVisible ? "Close" : "Open"}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
          <Grid container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Box>
                    <Tabs
                      value={selectedCategoryId || ""}
                      onChange={handleMainCategoryChange}
                      variant="scrollable"
                      scrollButtons
                      allowScrollButtonsMobile
                      aria-label="scrollable force tabs example"
                      sx={{
                        borderBottom: 1,
                        [`& .${tabsClasses.scrollButtons}`]: {
                          "&.Mui-disabled": { opacity: 0.3 },
                        },
                        "& .MuiTabs-scrollButtons svg": {
                          fontSize: 40,
                          color: "black",
                        },
                      }}
                      className={classes.orderListRightHeader2}
                    >
                      {categoryList &&
                        categoryList.map((category) => (
                          <Tab
                            key={category.id}
                            value={category.id}
                            label={
                              <Box
                                className={
                                  selectedCategoryId === category.id
                                    ? classes.orderListTabButtonSelect
                                    : classes.orderListTabButton
                                }
                              >
                                <ClassRoundedIcon />
                                <Typography
                                  sx={{
                                    px: 1,
                                  }}
                                  className={classes.tabTypograpy}
                                >
                                  {category.categoryName}
                                </Typography>
                              </Box>
                            }
                          />
                        ))}
                    </Tabs>
                  </Box>
                </Grid>
                {selectedCategoryId && subCategoryList.length > 0 && (
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    alignContent={"center"}
                  >
                    <Box>
                      <Tabs
                        value={
                          selectedSubCategoryId === null
                            ? ""
                            : selectedSubCategoryId
                        }
                        onChange={handleSubCategoryChange}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs example"
                        sx={{
                          borderBottom: 1,
                          [`& .${tabsClasses.scrollButtons}`]: {
                            "&.Mui-disabled": { opacity: 0.3 },
                          },
                          "& .MuiTabs-scrollButtons svg": {
                            fontSize: 40,
                            color: "black",
                          },
                        }}
                        className={classes.orderListRightHeader2}
                      >
                        {subCategoryList &&
                          subCategoryList.map((category) => (
                            <Tab
                              key={category.id}
                              value={category.id}
                              label={
                                <Box
                                  className={
                                    selectedSubCategoryId === category.id
                                      ? classes.orderListTabButtonSelect
                                      : classes.orderListTabButton
                                  }
                                >
                                  <ClassRoundedIcon />
                                  <Typography
                                    sx={{
                                      px: 1,
                                    }}
                                    className={classes.tabTypograpy}
                                  >
                                    {category.categoryName}
                                  </Typography>
                                </Box>
                              }
                            />
                          ))}
                      </Tabs>
                    </Box>
                  </Grid>
                )}
                {selectedCategoryId &&
                  selectedSubCategoryId &&
                  subToSubCategoryList.length > 0 && (
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                    >
                      <Box>
                        <Tabs
                          value={
                            selectedSubToSubCategoryId === null
                              ? ""
                              : selectedSubToSubCategoryId
                          }
                          onChange={handleSubToSubCategoryChange}
                          variant="scrollable"
                          scrollButtons
                          allowScrollButtonsMobile
                          aria-label="scrollable force tabs example"
                          sx={{
                            borderBottom: 1,

                            [`& .${tabsClasses.scrollButtons}`]: {
                              "&.Mui-disabled": { opacity: 0.3 },
                            },
                            "& .MuiTabs-scrollButtons svg": {
                              fontSize: 40,
                              color: "black",
                            },
                          }}
                          className={classes.orderListRightHeader2}
                        >
                          {subToSubCategoryList &&
                            subToSubCategoryList.map((category) => (
                              <Tab
                                key={category.id}
                                value={category.id}
                                label={
                                  <Box
                                    className={
                                      selectedSubToSubCategoryId === category.id
                                        ? classes.orderListTabButtonSelect
                                        : classes.orderListTabButton
                                    }
                                  >
                                    <ClassRoundedIcon />
                                    <Typography
                                      sx={{
                                        px: 1,
                                      }}
                                      className={classes.tabTypograpy}
                                    >
                                      {category.categoryName}
                                    </Typography>
                                  </Box>
                                }
                              />
                            ))}
                        </Tabs>
                      </Box>
                    </Grid>
                  )}
                {selectedCategoryId &&
                  selectedSubCategoryId &&
                  selectedSubToSubCategoryId &&
                  subToSubToSubCategoryList.length > 0 && (
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                    >
                      <Box>
                        <Tabs
                          value={
                            selectedSubToSubToSubCategoryId === null
                              ? ""
                              : selectedSubToSubToSubCategoryId
                          }
                          onChange={handleSubToSubToSubCategoryChange}
                          variant="scrollable"
                          scrollButtons
                          allowScrollButtonsMobile
                          aria-label="scrollable force tabs example"
                          sx={{
                            borderBottom: 1,
                            [`& .${tabsClasses.scrollButtons}`]: {
                              "&.Mui-disabled": { opacity: 0.3 },
                            },
                            "& .MuiTabs-scrollButtons svg": {
                              fontSize: 40,
                              color: "black",
                            },
                          }}
                          className={classes.orderListRightHeader2}
                        >
                          {subToSubToSubCategoryList &&
                            subToSubToSubCategoryList.map((category) => (
                              <Tab
                                key={category.id}
                                value={category.id}
                                label={
                                  <Box
                                    className={
                                      selectedSubToSubToSubCategoryId ===
                                      category.id
                                        ? classes.orderListTabButtonSelect
                                        : classes.orderListTabButton
                                    }
                                  >
                                    <ClassRoundedIcon />
                                    <Typography
                                      sx={{
                                        px: 1,
                                      }}
                                      className={classes.tabTypograpy}
                                    >
                                      {category.categoryName}
                                    </Typography>
                                  </Box>
                                }
                              />
                            ))}
                        </Tabs>
                      </Box>
                    </Grid>
                  )}
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              {isError ? (
                <Grid container justifyContent="center" sx={{ padding: 2 }}>
                  <Typography>Error fetching data</Typography>
                </Grid>
              ) : isLoading ? (
                <Grid container justifyContent="center" sx={{ padding: 2 }}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="10vh"
                  >
                    <CircularProgress />
                  </Box>
                </Grid>
              ) : coursings.length === 0 ? (
                <Grid container justifyContent="center" sx={{ padding: 2 }}>
                  <Typography>No data available</Typography>
                </Grid>
              ) : (
                <Box
                  sx={{
                    height: "90vh",
                    overflow: "auto",
                    padding: "2px",
                    "&::-webkit-scrollbar": {
                      width: "4px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#eeeeee",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#eeeeee",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#eeeeee",
                    },
                  }}
                >
                  <Grid container spacing={3} sx={{ padding: 2 }}>
                    {coursings.map((row: IVariantView, index) => (
                      <Grid item lg={2.4} md={4} sm={6} xs={12} key={row.id}>
                        <Card
                          className={classes.orderListProductCard}
                          // sx={{ padding: 2, height: "100%", cursor: "pointer" }}
                          // onClick={() => handleEditOpen(row)}
                          sx={{
                            padding: 2,
                            height: "100%",
                            cursor: !row.variantUnit ? "default" : "pointer",
                          }}
                          onClick={
                            row.variantUnit
                              ? () => handleEditOpen(row)
                              : undefined
                          }
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              textAlign="center"
                            >
                              <Grid
                                container
                                textAlign="center"
                                justifyContent={"center"}
                              >
                                <Grid
                                  item
                                  textAlign="center"
                                  className={
                                    classes.SelectImageTableBoxwithBorder2
                                  }
                                >
                                  {row.variantImg ? (
                                    <img
                                      src={row.variantImg}
                                      alt="img"
                                      // alt={row.variantName.toLowerCase()}
                                      className={classes.SelectImageTable70}
                                    />
                                  ) : (
                                    <ProductionQuantityLimitsIcon
                                      className={classes.SelectImageTable}
                                    />
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              textAlign="center"
                            >
                              {/* <Typography
                              className={classes.productCardTypograpy}
                            >
                              {row.variantName.length > 50
                                ? `${row.variantName.slice(0, 50)}...`
                                : row.variantName}
                            </Typography> */}
                              {row.variantName.length > 50 ? (
                                <Tooltip
                                  title={
                                    <>
                                      <Typography variant="body2">
                                        <strong>{row.variantName}</strong>
                                      </Typography>
                                    </>
                                  }
                                  sx={{ fontSize: "14px" }}
                                >
                                  <Typography
                                    className={classes.productCardTypograpy}
                                  >
                                    {`${row.variantName.slice(0, 50)}...`}
                                  </Typography>
                                </Tooltip>
                              ) : (
                                <Typography
                                  className={classes.productCardTypograpy}
                                >
                                  {row.variantName}
                                </Typography>
                              )}
                            </Grid>
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              sx={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                              }}
                            >
                              {!row.variantUnit && (
                                <CiEdit
                                  style={{
                                    fontSize: 28,
                                    // color: "red",
                                    cursor: row.variantUnit
                                      ? "default"
                                      : "pointer",
                                  }}
                                  onClick={
                                    !row.variantUnit
                                      ? () => handleOpenDialog(row)
                                      : undefined
                                  }
                                />
                              )}
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={4} md={6} sm={12} xs={12}>
        <Grid container spacing={1}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.orderListRightCard2}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 2, borderBottom: 4 }}
                className={classes.oLRightHeader}
              >
                <Grid
                  item
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-start"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      <Typography className={classes.orderLsitHeadingTypo}>
                        {ReDateId}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{ display: "flex" }}
                  >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Autocomplete
                        options={restaurantOptions}
                        loading={restauramtIsLoading}
                        getOptionLabel={(option: CustomerOption) =>
                          option.label
                        }
                        value={
                          restaurantOptions.find(
                            (opt) =>
                              opt.value === Number(formik.values.restaurantsId)
                          ) || null
                        }
                        onChange={(_, newValue: CustomerOption | null) => {
                          formik.setFieldValue(
                            "restaurantsId",
                            newValue?.value || ""
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Branch"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            className={classes.orderListTextField}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {restauramtIsLoading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}></Grid>
            </Card>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.orderListRightCard}>
              <Box
                sx={{
                  height: "80vh",
                  overflow: "auto",
                  padding: "2px",
                  "&::-webkit-scrollbar": {
                    width: "4px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#eeeeee",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#eeeeee",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#eeeeee",
                  },
                }}
              >
                <Grid sx={{ minHeight: 300 }}>
                  <TableContainer
                    className={classes.orTableContainer}
                    sx={{ width: "100%" }}
                  >
                    <Table sx={{ width: "100%" }}>
                      <TableHead className={classes.orTableHeaderRow}>
                        <TableRow>
                          <TableCell
                            className={classes.oLTablHeader}
                            sx={{ textAlign: "left", width: "50%" }}
                          >
                            <strong>Items</strong>
                          </TableCell>
                          <TableCell
                            className={classes.oLTablHeader}
                            sx={{ textAlign: "center", minWidth: 200 }}
                          >
                            <strong>Qty</strong>
                          </TableCell>
                          <TableCell
                            className={classes.oLTablHeader}
                            sx={{ textAlign: "right" }}
                          >
                            <strong>Action</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {orderList.map((row: IOrderItemEdit, index: number) => (
                          <TableRow
                            key={row.productId}
                            className={classes.tableRowHover}
                          >
                            <TableCell
                              className={classes.tablCell}
                              sx={{ textAlign: "left", width: "50%" }}
                            >
                              <Grid container spacing={1}>
                                <Grid item>
                                  <Typography className={classes.leftORTypo}>
                                    {row.variantName}{" "}
                                    <Typography
                                      component="span"
                                      className={classes.leftORTypo}
                                    >
                                      ({convertUnit(row.variantUnit)})
                                    </Typography>
                                  </Typography>
                                  <div
                                    style={{
                                      display: "flex",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      toggleRemarkContainer(row.productId)
                                    }
                                  >
                                    {row.remark ? (
                                      <Typography
                                        className={classes.leftORTypo}
                                      >
                                        {row.remark.length > 20
                                          ? `${row.remark.slice(0, 20)}...`
                                          : row.remark}
                                      </Typography>
                                    ) : (
                                      <Typography
                                        className={classes.leftORTypo}
                                      >
                                        Add Remark....
                                      </Typography>
                                    )}

                                    {/* <Grid
                                    onClick={() =>
                                      toggleRemarkContainer(row.productId)
                                    }
                                    sx={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    {openRemarkId === row.productId ? (
                                      <MdKeyboardArrowUp fontSize={22} />
                                    ) : (
                                      <MdKeyboardArrowDown fontSize={22} />
                                    )}
                                  </Grid> */}
                                  </div>
                                </Grid>
                                {openRemarkId === row.productId && (
                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    pb={3}
                                  >
                                    <TextField
                                      fullWidth
                                      size="small"
                                      value={row.remark}
                                      onChange={(e) =>
                                        handleQuantityChangeMain(
                                          e,
                                          "remark",
                                          index
                                        )
                                      }
                                      className={classes.oLTextField}
                                      multiline
                                      rows={6}
                                      InputProps={{
                                        sx: {
                                          fontSize: "13px",
                                        },
                                      }}
                                      InputLabelProps={{
                                        sx: {
                                          fontSize: "13px",
                                        },
                                      }}
                                    />
                                  </Grid>
                                )}
                              </Grid>
                            </TableCell>

                            <TableCell
                              className={classes.tablCell}
                              sx={{ textAlign: "center", minWidth: 200 }}
                            >
                              <TextField
                                size="small"
                                // type="number"
                                className={classes.oLQty}
                                value={row.productTotalUnit}
                                onChange={(e) =>
                                  handleQuantityChangeMain(
                                    e,
                                    "productTotalUnit",
                                    index
                                  )
                                }
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        // size="small"
                                        className={classes.oLQtyIconButton}
                                        onClick={() =>
                                          handleQuantityChangeMain(
                                            {
                                              target: {
                                                value: (
                                                  row.productTotalUnit - 1
                                                ).toString(),
                                              },
                                            } as React.ChangeEvent<HTMLInputElement>,
                                            "productTotalUnit",
                                            index
                                          )
                                        }
                                        disabled={row.productTotalUnit <= 0}
                                      >
                                        <RemoveIcon
                                          sx={{
                                            fontSize: "14px",
                                          }}
                                          // fontSize="small"
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        // size="small"
                                        className={classes.oLQtyIconButton}
                                        onClick={() =>
                                          handleQuantityChangeMain(
                                            {
                                              target: {
                                                value: (
                                                  row.productTotalUnit + 1
                                                ).toString(),
                                              },
                                            } as React.ChangeEvent<HTMLInputElement>,
                                            "productTotalUnit",
                                            index
                                          )
                                        }
                                      >
                                        <AddIcon
                                          sx={{
                                            fontSize: "14px",
                                          }}
                                          // fontSize="small"
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  sx: {
                                    fontSize: 14,
                                    textAlign: "center",
                                    "& input": {
                                      textAlign: "center",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: "8px",
                                      backgroundColor: "#f5f5f5",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "#1976d2",
                                      },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "#1976d2",
                                      },
                                  },
                                  classes: {
                                    root: classes.textFieldQuote2,
                                    notchedOutline: classes.notchedOutline,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: { fontSize: 14, border: "none" },
                                }}
                                sx={{
                                  width: "160px",
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                  },
                                }}
                              />
                            </TableCell>

                            <TableCell
                              className={classes.tablCell}
                              sx={{ textAlign: "right" }}
                            >
                              <Grid
                                container
                                spacing={1}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Grid item>
                                  <Button
                                    className={classes.oLDeleteButton}
                                    onClick={() =>
                                      handleDeleteRow(row.productId)
                                    }
                                  >
                                    <DeleteOutlineSharpIcon
                                      className={classes.oLEditListIcon}
                                    />
                                  </Button>
                                </Grid>
                              </Grid>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Box>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                p={1}
                pt={5}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  variant="contained"
                  startIcon={
                    isLoading ? (
                      <CircularProgress
                        size={18}
                        className={classes.isLoading}
                      />
                    ) : (
                      <AddIcon />
                    )
                  }
                  className={classes.oLConformButton}
                  onClick={() => formik.handleSubmit()}
                  disabled={!formValid}
                >
                  Updat Order List
                </Button>
              </Grid>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                p={1}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  variant="outlined"
                  startIcon={<CloseIcon />}
                  className={classes.oLOCancelButton}
                  onClick={handleCancelOrderList}
                >
                  Clear
                </Button>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        open={isEditDialogOpen}
        onClose={handleEditClose}
        aria-describedby="alert-dialog-description"
        classes={{ paper: "inherit" }}
        fullScreen={isMobileRes}
        fullWidth={isMobileRes}
        maxWidth="lg"
      >
        <Grid className={isMobileRes ? classes.DialogMobile : classes.Dialog}>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid item pt={2} alignContent={"center"}>
                        <Typography className={classes.cardTitle}>
                          {editData?.variantName || ""}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        pt={2}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="contained"
                          className={classes.editButton}
                          onClick={handleEditClose}
                        >
                          <CloseIcon />
                        </Button>
                      </Grid>
                    </Grid>
                    {editData?.variantUnit === 3 ? (
                      <Grid container spacing={3} p={"24px"}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                Quantity
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={3} sm={4} xs={6}>
                              <TextField
                                size="small"
                                type="number"
                                value={editData.quantityKgOrLi}
                                onChange={(e) =>
                                  handleQuantityChange(e, "quantityKgOrLi")
                                }
                                className={classes.textField}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Typography
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "bold",
                                          color: "gray",
                                          marginRight: "5px",
                                        }}
                                      >
                                        Kg
                                      </Typography>
                                    </InputAdornment>
                                  ),
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                            <Grid item lg={3} md={4} sm={5} xs={6}>
                              <TextField
                                size="small"
                                type="number"
                                value={editData.quantitySmallUnit}
                                onChange={(e) =>
                                  handleQuantityChange(e, "quantitySmallUnit")
                                }
                                className={classes.textField}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Typography
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "bold",
                                          color: "gray",
                                          marginRight: "5px",
                                        }}
                                      >
                                        g
                                      </Typography>
                                    </InputAdornment>
                                  ),
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                Remark
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                placeholder="Remark"
                                size="small"
                                value={editData.remark}
                                onChange={(e) =>
                                  handleQuantityChange(e, "remark")
                                }
                                className={classes.textField}
                                multiline
                                rows={4}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    ) : editData?.variantUnit === 5 ? (
                      <Grid container spacing={3} p={"24px"}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                Quantity
                              </Typography>
                            </Grid>
                            <Grid item lg={2} md={3} sm={4} xs={6}>
                              <TextField
                                size="small"
                                type="number"
                                value={editData.quantityKgOrLi}
                                onChange={(e) =>
                                  handleQuantityChange(e, "quantityKgOrLi")
                                }
                                className={classes.textField}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Typography
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "bold",
                                          color: "gray",
                                          marginRight: "5px",
                                        }}
                                      >
                                        l
                                      </Typography>
                                    </InputAdornment>
                                  ),
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                            <Grid item lg={3} md={4} sm={5} xs={6}>
                              <TextField
                                size="small"
                                type="number"
                                value={editData?.quantitySmallUnit}
                                onChange={(e) =>
                                  handleQuantityChange(e, "quantitySmallUnit")
                                }
                                className={classes.textField}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Typography
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "bold",
                                          color: "gray",
                                          marginRight: "5px",
                                        }}
                                      >
                                        ml
                                      </Typography>
                                    </InputAdornment>
                                  ),
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                Remark
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                placeholder="Remark"
                                size="small"
                                value={editData.remark}
                                onChange={(e) =>
                                  handleQuantityChange(e, "remark")
                                }
                                className={classes.textField}
                                multiline
                                rows={4}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    ) : editData?.variantUnit === 1 ||
                      editData?.variantUnit === 2 ||
                      editData?.variantUnit === 4 ||
                      editData?.variantUnit === 6 ||
                      editData?.variantUnit === 8 ||
                      editData?.variantUnit === 7 ? (
                      <Grid container spacing={3} p={"24px"}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                Quantity
                              </Typography>
                            </Grid>
                            <Grid item lg={6} md={6} sm={4} xs={6}>
                              <TextField
                                placeholder="Qty"
                                size="small"
                                type="number"
                                value={editData?.quantityKgOrLi}
                                onChange={(e) =>
                                  handleQuantityChange(e, "quantityKgOrLi")
                                }
                                className={classes.textField}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                Remark
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                placeholder="Remark"
                                size="small"
                                value={editData.remark}
                                onChange={(e) =>
                                  handleQuantityChange(e, "remark")
                                }
                                className={classes.textField}
                                multiline
                                rows={4}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid container spacing={3} p={"24px"}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              textAlign={"center"}
                            >
                              <Typography variant="subtitle1">
                                Add Conversion unit
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Card>
                </Grid>

                {/* Action Buttons */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleEditClose}
                        >
                          Cancel
                        </Button>
                        {(editData?.variantUnit === 1 ||
                          editData?.variantUnit === 2 ||
                          editData?.variantUnit === 4 ||
                          editData?.variantUnit === 6 ||
                          editData?.variantUnit === 7 ||
                          editData?.variantUnit === 3 ||
                          editData?.variantUnit === 8 ||
                          editData?.variantUnit === 5) && (
                          <>
                            <Box m={0.5}></Box>
                            <Button
                              variant="contained"
                              startIcon={<AddIcon />}
                              className={classes.addButton}
                              onClick={() => {
                                if (editData) {
                                  handleAddToOrder(editData);
                                  handleEditClose();
                                  // } else {
                                  //   console.error("editData is null. Cannot add to order.");
                                }
                              }}
                            >
                              Add
                            </Button>
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      {openTax && (
        <NewColor
          handleCloseDialog={() => setOpenTax(false)}
          openModel={openTax}
        />
      )}

      {selectedProduct && (
        <NewPopUpProduct
          openModel={openDialog}
          handleCloseDialog={handleCloseDialog}
          data={selectedProduct}
        />
      )}
    </Grid>
  );
};

export default Index;
